import { render, staticRenderFns } from "./twofactor.vue?vue&type=template&id=e4c05bac&"
import script from "./twofactor.js?vue&type=script&lang=js&"
export * from "./twofactor.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4c05bac')) {
      api.createRecord('e4c05bac', component.options)
    } else {
      api.reload('e4c05bac', component.options)
    }
    module.hot.accept("./twofactor.vue?vue&type=template&id=e4c05bac&", function () {
      api.rerender('e4c05bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/login/components/twofactor.vue"
export default component.exports